import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allEntHorarioClasesAction,
  setActivoEntHorarioClasesAction,
} from './EntHorarioClasesAction';
import FormEntHorarioClases from './components/FormEntHorarioClases';
import ListadoEntHorarioClases from './components/ListadoEntHorarioClases';

const EntHorarioClasesView = () => {
  const dispatch = Redux.useDispatch();

  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );

  React.useEffect(() => {
    setActivoEntHorarioClasesAction(dispatch, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoEntHorarioClasesAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoEntHorarioClasesAction(dispatch, null);
            await allEntHorarioClasesAction(
              dispatch,
              entHorariosClasesStore.params,
            );
          }}
          disabled={
            entHorariosClasesStore.all.length === 0 &&
            entHorariosClasesStore.loadingAll
          }
          white
          refreshIcon
          text={
            entHorariosClasesStore.loadingAll ? 'Actualizando...' : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        <ListadoEntHorarioClases
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      <ModalComponent
        id="modalFormEntHorarioClases"
        title={
          entHorariosClasesStore.activo
            ? `Editar Horario de clases`
            : 'Nuevo Horario de clases'
        }
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEntHorarioClases
          activo={entHorariosClasesStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default EntHorarioClasesView;
